import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useExtendedQuery from '../../hooks/useExtendedQuery';
import { userPropertiesType } from '../../types';
import './_styles_/UserDetailTab.css';
import { ON_USER_CHANGED, USER_DETAIL } from '../../graphql/users';
import UserDetailTab from './UserDetailTab';
import Spinner from '../Spinner';
import useExtendedSubscription from '../../hooks/useExtendedSubscription';
import Error from '../errors/Error';

UserDetail.propTypes = {
    id: PropTypes.number.isRequired,
    userProps: userPropertiesType.isRequired,
};

function UserDetail(props) {
    const {
        id,
        userProps,
    } = props;
    const variables = useMemo(() => ({
        id,
    }), [id]);
    const {
        loading,
        error,
        data,
        refetch,
    } = useExtendedQuery(USER_DETAIL, {
        variables,
        variablesToUrl: false,
    });
    useExtendedSubscription(ON_USER_CHANGED, {
        refetch,
        refetchVariables: variables,
        dataProperty: 'userChanged',
    });
    let result;
    if (loading) {
        result = <Spinner className="user-detail-loading" />;
    } else if (error) {
        result = <Error className="user-detail-error" error={error} />;
    } else {
        result = (
            <UserDetailTab
                user={data.userDetail}
                userProps={userProps}
            />
        );
    }
    return result;
}

export default UserDetail;
